import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectedComponent } from './selected.component';



@NgModule({
  declarations: [
    SelectedComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SelectedComponent,
  ]
})

export class SelectedModule { }
